import React from 'react';
import { motion } from 'framer-motion';

interface BackButtonProps {
  onClick: () => void;
  label?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick, label = 'HOME' }) => {
  return (
    <motion.button
      onClick={onClick}
      whileHover={{ scale: 1.05, x: -5 }}
      whileTap={{ scale: 0.95 }}
      className="fixed top-20 left-4 z-40 terminal-card px-4 py-2"
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.3 }}
    >
      <div className="terminal-header">
        <div className="flex items-center space-x-2">
          <div className="w-1 h-1 bg-red-500 rounded-full"></div>
          <div className="w-1 h-1 bg-yellow-500 rounded-full"></div>
          <div className="w-1 h-1 bg-green-400 rounded-full"></div>
        </div>
        <div className="flex-1 text-center text-xs">
          NAV.EXE
        </div>
      </div>
      
      <div className="terminal-content py-2">
        <div className="flex items-center space-x-2 text-xs font-mono">
          <span className="text-white/60">&lt;</span>
          <span className="text-white cyber-glow">{label}</span>
        </div>
      </div>
    </motion.button>
  );
};

export default BackButton;